module.exports = __webpack_public_path__ + "static/media/alberta.bb35853f.jpg";